if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.disableCartDrawer = this.dataset.disableCartDrawer === 'true';

        if (document.querySelector('cart-drawer') && !this.disableCartDrawer) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      setLoader(load) {
          if (load) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.classList.add('loading');
              this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
          } else {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          }
      }

      getSectionInnerHTML(html, selector = '.shopify-section') {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const node = parsed.querySelector(selector);
          return node ? node.innerHTML : null;
      }

      updateCartSections(parsedState) {
          if (!parsedState || !parsedState.sections) return;

          const cartIconElement = document.getElementById('cart-icon-bubble');
          const cartIconSection = parsedState.sections['cart-icon-bubble'];
          if (cartIconElement && cartIconSection) {
              const cartIconMarkup = this.getSectionInnerHTML(cartIconSection, '.shopify-section');
              if (cartIconMarkup !== null) {
                  cartIconElement.innerHTML = cartIconMarkup;
              }
          }

          const cartDrawerElement = document.getElementById('CartDrawer');
          const cartDrawerSection = parsedState.sections['cart-drawer'];
          if (cartDrawerElement && cartDrawerSection) {
              const cartDrawerMarkup = this.getSectionInnerHTML(cartDrawerSection, '#CartDrawer');
              if (cartDrawerMarkup !== null) {
                  cartDrawerElement.innerHTML = cartDrawerMarkup;
              }
          }

          if (this.cart && this.cart.classList && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
          }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.setLoader(true);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (!this.disableCartDrawer) {
              this.cart.setActiveElement(document.activeElement);
          }
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        publish(PUB_SUB_EVENTS.cartError, {
                            source: 'product-form',
                            productVariantId: formData.get('id'),
                            errors: response.errors || response.description,
                            message: response.message,
                        });
                        this.handleErrorMessage(response.description);

                        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                        if (!soldOutMessage) return;
                        this.submitButton.setAttribute('aria-disabled', true);
                        this.submitButton.querySelector('span').classList.add('hidden');
                        soldOutMessage.classList.remove('hidden');
                        this.error = true;
                        return;
                    } else if (!this.cart) {
                        window.location = window.routes.cart_url;
                        return;
                    }

                    if (!this.error)
                        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
                    this.error = false;

                    if (this.disableCartDrawer) {
                        this.updateCartSections(response);
                        this.dispatchEvent(
                            new CustomEvent('product:added', {
                                bubbles: true,
                                detail: { cartData: response, productVariantId: formData.get('id') },
                            })
                        );
                        return;
                    }

                    const quickAddModal = this.closest('quick-add-modal');
                    if (quickAddModal) {
                        document.body.addEventListener(
                            'modalClosed',
                            () => {
                                setTimeout(() => {
                                    this.cart.renderContents(response);
                                });
                            },
                            { once: true }
                        );
                        quickAddModal.hide(true);
                    } else {
                        this.cart.renderContents(response);
                    }
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    this.setLoader(false);
                });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
